import * as Yup from "yup";

export const campusSchema = Yup.object().shape({
  location: Yup.string().required("Location field cannot be empty"),
  institution_id: Yup.string().required("Institution is required"),
});
